import React from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { LogIn, User, ShieldCheck } from 'lucide-react';
import SaleBanner from '@/components/SaleBanner';

export default function Navbar() {
  const { user, logout } = useAuth();
  return (
    <header
      data-testid="site-navbar"
      className="fixed top-0 inset-x-0 z-50 glass-strong border-b border-white/[0.06]"
    >
      <SaleBanner />
      <div className="mx-auto max-w-7xl px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-home-link" className="flex items-center gap-2.5 group">
          <span className="relative h-8 w-8 shrink-0 flex items-center justify-center">
            <span className="absolute inset-0 rounded-xl bg-brand/25 blur-md group-hover:bg-brand/50 transition-colors" />
            <img
              src="/logo.png"
              alt="Lucky Scripts"
              className="relative h-8 w-8 object-contain select-none drop-shadow-[0_0_6px_rgb(var(--brand-rgb)/0.65)]"
              draggable={false}
            />
          </span>
          <span className="font-display font-bold tracking-tight text-white text-lg">
            Lucky<span className="text-brand">Scripts</span>
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70">
          <NavLink data-testid="nav-products" to="/#products" className="hover:text-white transition-colors">Products</NavLink>
          <NavLink data-testid="nav-vip" to="/#vip" className="hover:text-white transition-colors">VIP</NavLink>
          {user && (
            <NavLink data-testid="nav-dashboard" to="/dashboard" className="hover:text-white transition-colors">Dashboard</NavLink>
          )}
          {user?.role === 'admin' && (
            <NavLink data-testid="nav-admin" to="/admin" className="hover:text-white transition-colors flex items-center gap-1">
              <ShieldCheck className="h-4 w-4" /> Admin
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {!user ? (
            <>
              <Link
                data-testid="nav-login-btn"
                to="/login"
                className="hidden sm:inline-flex items-center gap-1.5 text-sm text-white/80 hover:text-white px-3 py-2 rounded-full hover:bg-white/5 transition-colors"
              >
                <LogIn className="h-4 w-4" /> Log in
              </Link>
              <Link
                data-testid="nav-signup-btn"
                to="/register"
                className="inline-flex items-center text-sm font-medium bg-brand text-[#0b0b0b] px-4 py-2 rounded-full hover:bg-brand/90 hover:shadow-[0_0_24px_rgb(var(--brand-rgb)/0.6)] transition-shadow"
              >
                Sign up
              </Link>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <Link
                data-testid="nav-user-badge"
                to="/dashboard"
                className="hidden sm:flex items-center gap-2 text-sm text-white/80 px-3 py-1.5 rounded-full bg-white/5 border border-white/10 hover:bg-white/10 transition-colors"
              >
                <User className="h-4 w-4" />
                <span className="max-w-[160px] truncate">{user.email}</span>
                {user.is_vip && <span className="text-[10px] uppercase tracking-widest text-brand">VIP</span>}
              </Link>
              <button
                data-testid="nav-logout-btn"
                onClick={logout}
                className="text-sm text-white/60 hover:text-white px-3 py-2 rounded-full hover:bg-white/5 transition-colors"
              >
                Log out
              </button>
            </div>
          )}
        </div>
      </div>
    </header>
  );
}
